import React from 'react';
import FooterInfo from './FooterInfo.jsx';
import SocialShare from './SocialShare.jsx';
import { useGlobalContext } from '../../js/context.js';
import './Footer.scss'

const Footer = () => {
  const { page } = useGlobalContext();

  const isMenuOrElementPage =
    page && (page === 'menu_page' || page === 'element_page');

  return (
    <div className={`tos-footer ${isMenuOrElementPage ? 'tos-footer--details' : ''}`}>
      {isMenuOrElementPage && <FooterInfo />}
      <SocialShare />
      <span className='tos-footer__copyright'>
        &copy; Philip Morris Products S.A.
      </span>
    </div>
  );
};

export default Footer;
